/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';

import { Select } from 'antd';
import ErrorField from '~/components/ErrorField';
import { BoxInput, Label } from './style';

const { Option } = Select;

const SelectInput = ({
  selectData = [],
  label = 'Label',
  name,
  onChange: formik,
  hasError = '',
  disabled = false,
  ...rest
}) => {
  return (
    <BoxInput>
      <Label>{label}</Label>
      <Select
        id={name}
        defaultValue="Selecione"
        style={{ width: '100%', height: 35 }}
        onChange={value => {
          formik.setFieldValue(name, value);
        }}
        disabled={disabled}
        {...rest}
      >
        {selectData.map(({ codigo, descricao }) => {
          return (
            <Option key={codigo} value={codigo}>
              {descricao}
            </Option>
          );
        })}
      </Select>

      {hasError && <ErrorField message={hasError} />}
    </BoxInput>
  );
};

export default SelectInput;
export { SelectInput };
